import React from "react";
import {AbstractLiveblogElement} from "./AbstractLiveblogElement";
import {PropsParser} from "@webng/validations";
import {SharedThemeConfiguration} from "@webng-types/embedjs";
import {LiveblogPortalWidget} from "./liveblog-portal/LiveblogPortalWidget";
import {
  LiveblogPortalWidgetApi,
  LiveblogPortalWidgetProps,
  LiveblogPortalWidgetQueryProps,
  liveblogPortalWidgetQueryPropsParser,
  LiveblogPortalWidgetTagProps,
  liveblogPortalWidgetTagPropsParser
} from "./liveblog-portal/LiveblogPortalWidgetProps";
import {rawSharedThemeConfigurationSchema} from "@webng-types/embedjs/shared";

const propsParser: PropsParser<LiveblogPortalWidgetTagProps> = {
  ...liveblogPortalWidgetTagPropsParser,
};

export class TickarooLiveblogPortalElement extends AbstractLiveblogElement<{}, LiveblogPortalWidgetTagProps, LiveblogPortalWidgetQueryProps, LiveblogPortalWidgetApi> {
  static get observedAttributes() {
    return [
      ...Object.keys(propsParser).map((x) => x.toLowerCase()),
      ...Object.keys(rawSharedThemeConfigurationSchema.shape).map((x) =>
        x.toLowerCase()
      ),
    ];
  }

  constructor() {
    super(liveblogPortalWidgetTagPropsParser, liveblogPortalWidgetQueryPropsParser);
  }

  parseConfigurationProps(metaValues: Record<string, string>, elementAttributes: Record<string, string>): Partial<{}> {
    return {};
  }

  useHydrate(props: {
    tagProps: LiveblogPortalWidgetTagProps;
    queryProps: LiveblogPortalWidgetQueryProps;
    overrideSharedConfiguration: Partial<SharedThemeConfiguration>;
    overrideConfiguration: Partial<{}>
  }): boolean {
    return false;
  }



  renderImp(ref: (r: LiveblogPortalWidgetApi) => void, props: {
    tagProps: LiveblogPortalWidgetProps;
    queryProps: LiveblogPortalWidgetQueryProps;
    overrideSharedConfiguration: Partial<SharedThemeConfiguration>;
    overrideConfiguration: Partial<{}>;
  }): React.ReactNode {
    const finalProps = Object.assign({}, props.tagProps, props.queryProps);
    return <LiveblogPortalWidget ref={ref} {...finalProps} />;
  }
}
